
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Borku from './pages/caseStudies/Borku/borku';
import Yalla from './pages/caseStudies/Yalla/yalla';
import GroovePacker from './pages/caseStudies/GroovePacker/groovePacker';
import ScrollToTop from './components/ScrollToTop';
import TermsConditions from './pages/Legal/terms-conditions';
import PrivacyPolicy from './pages/Legal/privacy-policy';
import PaymentGatewaysMgt from './pages/speacialities/PaymentGatewaysMgt/paymentGatewaysMgt';
import FleetManagement from './pages/speacialities/Fleet Management/fleetManagement';
import MultivendorSolution from './pages/speacialities/Multivendor Solution/multivendorSolution';
import AnalyticsReporting from './pages/speacialities/Analytics and Reporting/analyticsReporting';
import RoleManagement from './pages/speacialities/Role Management Solutions/roleManagement';
import InterdeviceCommunicationMgt from './pages/speacialities/Interdevice Communication Mgt/interdeviceCommunicationMgt';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import NotFound from './pages/NotFound/NotFound';
import Blogs from './pages/Blogs/Blogs';
import SingleBlogPage from './pages/SingleBlog/SingleBlog';
import QuoteForm from './pages/GetQuoteForm/QuoteForm';
const App = () => {
  return (

    <HelmetProvider>
      <Helmet>
        <title>Fast & Custom Delivery Solutions for Business | Ninjas Code</title>
        <meta name="description" content="Launch your delivery platform in a month with Ninjas Code. Get scalable, custom solutions tailored to your business needs. Book a consultation today!" />
        </Helmet>
    <Router>
       <ScrollToTop />
      <Header/>
        <main>
          <Routes>
         
            <Route path="/" element={<Home/>}/>
            <Route path="/borku" element={<Borku/>}/>
            <Route path="/yalla" element={<Yalla/>}/>
            <Route path="/groove-packer" element={<GroovePacker/>}/>
            <Route path="/payment-gateways-management" element={<PaymentGatewaysMgt/>}/>
            <Route path="/fleet-management" element={<FleetManagement/>}/>
            <Route path="/multivendor-ecommerce-solutions" element={<MultivendorSolution/>}/>
            <Route path="/analytics-and-reporting" element={<AnalyticsReporting/>}/>
            <Route path="/role-management" element={<RoleManagement/>}/>
            <Route path="/interdevice-communications-management" element={<InterdeviceCommunicationMgt/>}/>
            <Route path="/terms-conditions" element={<TermsConditions/>}></Route>
            <Route path="/privacy-policy" element={<PrivacyPolicy/>}></Route>
            <Route path="*" element={<NotFound />} />
            <Route path="/blog" element={<Blogs/>}/>
            <Route path="/blog/:slug" element={<SingleBlogPage />} />
            <Route path="/contact" element={<QuoteForm />}/>
          </Routes>
        </main>
      <Footer/>
    </Router>
</HelmetProvider>
  );
};

export default App;